module.exports = require("./gd-GB");